module.exports = __webpack_public_path__ + "static/media/songActive.c0252a35.svg";